import { CustomField as CustomFieldProps, CustomFieldElementType, ExtraField } from '@web/graphql-types'
import React from 'react'
import TextArea from './components/TextArea'
import SingleSelect from './components/SingleSelect'
import MultiSelect from './components/MultiSelect'
import TextInput from './components/TextInput'
import Checkbox from './components/Checkbox'
import { useOptionalExtraFieldsContext } from '../ExtraFields/ExtraFieldsContext'
import Switch from './components/Switch'
import { Box } from '@web/components/atoms/Layout'

// We want to accept any component type here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const COMPONENTS: { [key in CustomFieldElementType]: any } = {
  [CustomFieldElementType.InputText]: TextInput,
  [CustomFieldElementType.SingleSelect]: SingleSelect,
  [CustomFieldElementType.MultiSelect]: MultiSelect,
  [CustomFieldElementType.TextArea]: TextArea,
  [CustomFieldElementType.Checkbox]: Checkbox,
  [CustomFieldElementType.DatePicker]: undefined,
  [CustomFieldElementType.Dropdown]: SingleSelect,
  [CustomFieldElementType.RadioButton]: undefined,
  [CustomFieldElementType.Hidden]: undefined,
  [CustomFieldElementType.Switch]: Switch,
}

export type CustomFieldComponentProps = ExtraField &
  CustomFieldProps & {
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement>) => void
    value?: string | number | string[] | undefined
    CustomFieldComponent?: React.FC<CustomFieldComponentProps>
  }

const CustomFieldComponent = (props: CustomFieldComponentProps) => {
  const extraFields = useOptionalExtraFieldsContext()
  if (!COMPONENTS[props.elementType]) {
    return null
  }

  return (
    <Box display="contents" visibility={props.isHidden ? 'hidden' : 'visible'}>
      {React.createElement(COMPONENTS[props.elementType], {
        key: `${props.name}-field`,
        ...props,
        value: props.value ?? extraFields?.values[props.id] ?? '',
        CustomFieldComponent,
      })}
    </Box>
  )
}

export default CustomFieldComponent
